import './observability';

import { bootstrapApplication } from '@angular/platform-browser';
import {
  RouteReuseStrategy,
  provideRouter,
  withPreloading,
  PreloadAllModules,
} from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor } from './app/auth/auth.interceptor';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';

import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone';

import { provideAuth } from 'angular-auth-oidc-client';

import { routes } from './app/app.routes';
import { provideInternalNotifications } from './app/services/infrastructure/internal-notifications/internal-notifications.provider';
import { provideItTickets } from './app/services/infrastructure/it-tickets/it-tickets.provider';
import { provideMailing } from './app/services/infrastructure/mailing/mailing.provider';
import { provideLeads } from './app/services/infrastructure/leads/leads.provider';
import { provideAcquisition } from './app/services/infrastructure/acquisition/acquisition.provider';
import { provideQuotes } from './app/services/infrastructure/quotes/quotes.provider';
import { provideCoverage } from './app/services/infrastructure/coverage/coverage.provider';
import { providePricing } from './app/services/infrastructure/pricing/pricing.provider';
import { provideSupplyChain } from './app/services/infrastructure/supply-chain/supply-chain.provider';
import { provideTags } from './app/services/infrastructure/tags/tags.provider';
import { AppComponent } from './app/app.component';
import { authConfig } from './app/auth/auth.config';
import { ErrorHandler, isDevMode } from '@angular/core';
import { provideServiceWorker } from '@angular/service-worker';
import { registerLocaleData } from '@angular/common';
import localeEsMx from '@angular/common/locales/es-MX';
import * as Sentry from '@sentry/angular';
import { environment } from '@env';
import {
  GOOGLE_MAPS_API_KEY,
  GOOGLE_MAPS_MAP_ID,
} from './app/services/google-maps/google-maps-loader.service';
import { Environment } from './app/utils/environment.util';
registerLocaleData(localeEsMx, 'es-MX');

// Fuera de producción el primario es naranja (ver .stage-* en variables.scss)
document.documentElement.classList.add(`stage-${Environment.stageName}`);

bootstrapApplication(AppComponent, {
  providers: [
    { provide: ErrorHandler, useValue: Sentry.createErrorHandler() },
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideIonicAngular(),
    provideHttpClient(withInterceptors([authInterceptor])),
    // Sin llave o sin Map ID no hay mapa dinámico: la sección avisa «Mapa no disponible»
    { provide: GOOGLE_MAPS_API_KEY, useValue: environment.googleMaps.apiKey || null },
    { provide: GOOGLE_MAPS_MAP_ID, useValue: environment.googleMaps.mapId || null },
    provideItTickets(),
    provideMailing(),
    provideLeads(),
    provideAcquisition(),
    provideQuotes(),
    provideCoverage(),
    providePricing(),
    provideSupplyChain(),
    provideTags(),
    provideInternalNotifications(),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    provideAuth(authConfig),
    provideTranslateService({
      lang: 'es',
      fallbackLang: 'es',
    }),
    provideTranslateHttpLoader({
      prefix: './assets/i18n/',
      suffix: '.json',
    }),
    provideServiceWorker('ngsw-worker.js', {
      // Configuración del Service Worker para Progressive Web App (PWA)
      enabled: !isDevMode(), // Habilitar solo en modo producción para evitar interferencias durante el desarrollo
      registrationStrategy: 'registerWhenStable:30000', // Registro diferido hasta que la aplicación esté estable o hayan pasado 30 segundos
    }),
  ],
});
